import type { BackgroundJobSummary } from '../../shared/background-jobs';

export type UiTaskStatus = 'queued' | 'running' | 'complete' | 'failed';

export interface UiTask {
  id: string;
  source: 'background' | 'local';
  kind: string;
  title: string;
  status: UiTaskStatus;
  progress: number;
  stage: string;
  updatedAt: string;
  errorMessage: string | null;
  retryable: boolean;
  remoteJob?: BackgroundJobSummary;
}

const RUNNING = new Set(['collecting','snapshot','rendering','packaging_media','checksum']);

export function backgroundJobTask(job: BackgroundJobSummary): UiTask {
  const status: UiTaskStatus = job.status === 'queued'
    ? 'queued'
    : RUNNING.has(job.status)
      ? 'running'
      : job.status === 'complete'
        ? 'complete'
        : 'failed';
  return {
    id: `background:${job.id}`,
    source: 'background',
    kind: job.jobType,
    title: job.targetTitle || job.artifactFilename || job.id,
    status,
    progress: Math.max(0, Math.min(100, job.progress)),
    stage: job.progressStage || job.status,
    updatedAt: job.updatedAt,
    errorMessage: job.status === 'failed' ? job.errorMessage : null,
    retryable: job.status === 'failed',
    remoteJob: job
  };
}

export function sortTasks(tasks: readonly UiTask[]): UiTask[] {
  const rank: Record<UiTaskStatus, number> = { failed: 0, running: 1, queued: 2, complete: 3 };
  return [...tasks].sort((a, b) => rank[a.status] - rank[b.status]
    || Date.parse(b.updatedAt) - Date.parse(a.updatedAt)
    || a.id.localeCompare(b.id));
}

export function taskCounts(tasks: readonly UiTask[]) {
  return {
    active: tasks.filter(task => task.status === 'queued' || task.status === 'running').length,
    attention: tasks.filter(task => task.status === 'failed').length,
    complete: tasks.filter(task => task.status === 'complete').length
  };
}
